import CardsToolbar from "componentsv2/card/CardsToolbar";
import TableTitle from "componentsv2/table/TableTitle";
import Counter from "componentsv2/widgets/Counter";

function CardHeader({ layout, handleView, storeId, count, kind }) {
  return (
    <div
      id="table-header"
      className="md:flex md:flex-wrap md:py-1 max-md:mt-12"
    >
      <TableTitle layout={layout} kind={kind} />
      <CardsToolbar
        actions={layout.table_action}
        layout={layout}
        storeId={storeId}
        handleView={handleView}
        kind={kind}
        count={count}
      />
    </div>
  );
}

export default CardHeader;
